/* eslint-disable no-case-declarations */
/* eslint-disable react/jsx-no-constructed-context-values */
/*
 * Author M. Atoar Rahman
 * Title: Donation Context Context
 * Description: Donation Context Context
 * Date: 15/07/2022
 */

import { createContext, useContext, useState } from 'react';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import UrlService from '../../../services/UrlService';
import ToastifyService from '../../../services/ToastifyService';
import { reload } from '../../../Utils';

// Create Context
const ContextAPI = createContext();

export function useDonation() {
    return useContext(ContextAPI);
}

// Provider Component
export function DonationProvider({ children }) {
    // Dependency
    const axiosPrivate = useAxiosPrivate();

    const [show, setShow] = useState(false);
    const [data, setData] = useState();
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [donateData, setDonateData] = useState({});
    const [donateList, setDonateList] = useState({});
    const [rowData, setRowData] = useState({});
    const [rowDataList, setRowDataList] = useState({});
    const [showPdf, setShowPdf] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const getAllData = async () => {
        try {
            const response = await axiosPrivate.get(UrlService.getAllDonationUrl(), {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            setData(response?.data?.donation_list);
        } catch (err) {
            if (!err?.response) {
                console.log('Server Not Responding!');
            } else if (err.response?.status === 401) {
                console.log('Unauthorized!');
            } else {
                console.log('Data Not Found!');
            }
        }
    };

    // API Function: Add/Edit Data
    const addOrUodateData = async (data_sunmit, id) => {
        try {
            const response = await axiosPrivate.post(
                id ? UrlService.updateOuterAgencyUrl(id) : UrlService.saveOuterAgencyUrl(),
                JSON.stringify(data_sunmit),
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (response?.data?.status === 'error') {
                setIsSubmitted(false);
                // Handle nested error messages (e.g., { email: ["message"] })
                if (response?.data?.msg && typeof response?.data?.msg === 'object') {
                    const errorMessages = Object.entries(response?.data?.msg)
                        .map(([field, errors]) => {
                            const errorArray = Array.isArray(errors) ? errors : [errors];
                            return `${field}: ${errorArray.join(', ')}`;
                        })
                        .join('\n');
                    ToastifyService.errorNotify(errorMessages);
                } else {
                    ToastifyService.errorNotify(response?.data?.msg || response?.data?.message || 'Error occurred');
                }
            } else {
                await getAllData();
                setIsSubmitted(true);
                if (id != null) {
                    ToastifyService.updateNotify('Data Update Successfull');
                } else {
                    ToastifyService.saveNotify('Data Create Successfull');
                    reload();
                }
            }
        } catch (err) {
            setIsSubmitted(false);
            if (!err?.response) {
                setErrMsg('Server Not Responding!');
            } else if (err.response?.status === 401) {
                setErrMsg('Unauthorized!');
            } else if (id) {
                setErrMsg('Data Update Failed!');
            } else {
                setErrMsg('Data Insert Failed!');
            }
            ToastifyService.errorNotify(errMsg);
        }
    };

    // Add OuterAgency
    const addOuterAgency = (value) => {
        addOrUodateData(value);
    };

    return (
        <ContextAPI.Provider
            value={{
                show,
                setShow,
                data,
                setData,
                getAllData,
                donateData,
                setDonateData,
                donateList,
                setDonateList,
                isSubmitted,
                setIsSubmitted,
                rowData,
                setRowData,
                rowDataList,
                setRowDataList,
                showPdf,
                setShowPdf,
                addOuterAgency,
            }}
        >
            {children}
        </ContextAPI.Provider>
    );
}

export default ContextAPI;
